import React, { useId } from 'react'
import PropTypes from 'prop-types'

const EnvelopeIcon = React.forwardRef(function EnvelopeIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-0.00999451 5C-0.00999451 3.89772 0.887721 3 1.99001 3H22.02C23.1223 3 24.02 3.89772 24.02 5V19.0091L24.0198 19.0182C24.0001 20.1027 23.1157 21 22.01 21H1.99001C0.887721 21 -0.00999451 20.1023 -0.00999451 19V5ZM22.02 5H1.99001V19H22.0088C22.0097 18.9995 22.0111 18.9984 22.0128 18.9967C22.0158 18.9938 22.0178 18.9906 22.0189 18.9882C22.0194 18.9869 22.0198 18.9857 22.02 18.9842V5Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.01 12.7635L1.59817 5.19125L0.421829 6.80873L12.01 15.2365L23.5982 6.80873L22.4218 5.19125L12.01 12.7635Z"
        ></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

EnvelopeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

EnvelopeIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default EnvelopeIcon
